var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Component } from "react";
import AvatarEditor from "react-avatar-editor";
import Slider from "../FormItem/Slider";
import Button from "../Button";
import { EditorContainer } from "./styled";
var ImageEditor = /** @class */ (function (_super) {
    __extends(ImageEditor, _super);
    function ImageEditor() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onComplete = function () {
            var resizedImage = _this.getImage();
            _this.props.onComplete(resizedImage);
        };
        _this.editorRef = null;
        _this.getImage = function () {
            return _this.editorRef.getImageScaledToCanvas();
        };
        return _this;
    }
    ImageEditor.prototype.render = function () {
        var _this = this;
        var _a = this.props, scale = _a.scale, landscapeIcon = _a.landscapeIcon, onUpdate = _a.onUpdate, buttonText = _a.buttonText, showSlider = _a.showSlider, largeBtn = _a.largeBtn, centerSlider = _a.centerSlider, props = __rest(_a, ["scale", "landscapeIcon", "onUpdate", "buttonText", "showSlider", "largeBtn", "centerSlider"]);
        return (React.createElement(React.Fragment, null,
            React.createElement(EditorContainer, null,
                React.createElement(AvatarEditor, __assign({ ref: function (el) { _this.editorRef = el; }, scale: scale }, props))),
            showSlider &&
                React.createElement(Slider, { landscapeIcon: landscapeIcon, imageScale: scale, onUpdate: onUpdate, centerSlider: centerSlider }),
            buttonText &&
                React.createElement(Button, { onClick: this.onComplete, primary: true, large: largeBtn }, buttonText)));
    };
    ImageEditor.defaultProps = {
        showSlider: true,
        landscapeIcon: false,
        largeBtn: true,
        centerSlider: true,
        onComplete: function () { }
    };
    return ImageEditor;
}(Component));
export default ImageEditor;
